import React from "react";
import TicketItem from "./TicketItem";

const TicketItemsList = () => {
  return (
    <div>
      mapped ticket content
      <div>
        <TicketItem />
        <TicketItem />
        <TicketItem />
      </div>
    </div>
  );
};

export default TicketItemsList;
